import {
    ORDER_APPROVER_CHANGE_CURRENTPAGE,
    ORDER_APPROVER_CHANGE_MODE,
    ORDER_ERROR,
    ORDER_SET_LOADING_STATUS,
    ORDER_APPROVER_SET_ORDER, 
    ORDER_APPROVER_SET_LIST,
    ORDER_APPROVER_RECEIVE,
    ORDER_APPROVER_SET_APPROVED_RESPONSE,
    ORDER_APPROVER_SET_REJECTED_RESPONSE,
    ViewMode,
} from '../constants';
import { error as errorReducer } from './Error.reducer';

const defaultState = {
    mode: ViewMode.List,
    orders: [],
    order: {},
    totalCount: 0,
    errors: {},
    isLoadingList: true,
    isLoadingDetails: true,
    orderApprovedResponse: null,
    orderRejectedResponse: null
};

export const orderApprover = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case ORDER_APPROVER_RECEIVE:
        case ORDER_APPROVER_CHANGE_MODE:
        case ORDER_APPROVER_CHANGE_CURRENTPAGE:
        case ORDER_APPROVER_SET_ORDER:
        case ORDER_APPROVER_SET_LIST:
        case ORDER_SET_LOADING_STATUS:
        case ORDER_APPROVER_SET_APPROVED_RESPONSE:
        case ORDER_APPROVER_SET_REJECTED_RESPONSE:
            return {
                ...state,
                errors: {},
                ...payload,
            };
        case ORDER_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action),
            };
        default:
            return state;
    }
};
